import { render } from "./News13.vue?vue&type=template&id=62ded7f7&scoped=true"
import script from "./News13.vue?vue&type=script&lang=js"
export * from "./News13.vue?vue&type=script&lang=js"

import "./News13.vue?vue&type=style&index=0&id=62ded7f7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ded7f7"]])

export default __exports__